import { validate as uuidValidate } from 'uuid';
import {APP_ENV, IS_STAGING} from "./Constants";

export function isValidUuid(uuid: string) {
  if (uuid) {
    return uuidValidate(uuid)
  }
  return false
}

export function filterAlphanumeric(input: string) {
  return input?.replace(/[^a-z0-9]/gi, '')
}

export function asset(file: string) {
  return (
    (IS_STAGING
      ? process.env.PUBLIC_URL
      : APP_ENV === 'testing'
      ? 'https://testing-sp.contester.net'
      : 'https://sp.contester.net') +
    '/' +
    file
  )
}

export function formatTime(seconds = 0) {
  let s = Math.floor(seconds % 60)
  let m = Math.floor((seconds / 60) % 60)

  // Always show at least one digit of minutes.
  let mm = `${m < 10 ? `0${m}` : m}:`

  // Check if leading zero is need for seconds
  let ss = s < 10 ? `0${s}` : s

  return mm + ss
}
